export enum SubmitStatus {
  Idle = 'idle',
  Loading = 'loading',
}
